import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Subscription } from "src/app/shared/models/DTO/VenueFinance.dto";

@Component({
	selector: "app-service-subscription-dashboard",
	templateUrl: "./service-subscription-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ServiceSubscriptionDashboardComponent implements OnInit {
	@Input() service: Subscription;
	@Output() serviceChange = new EventEmitter<Subscription>();

	monthlyBillingTotal: number = 0;
	billingDates: {
		date: string;
		amount: number;
	}[] = [];

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.venueFinance.subscribe((data) => {
			if (data.subscriptions) {
				this.buildDashboard(data.subscriptions);
			}
		});

		if (this.venueService.venueFinance.value.subscriptions) {
			this.buildDashboard(this.venueService.venueFinance.value.subscriptions);
		}
	}

	buildDashboard(serviceList: Subscription[]) {
		this.billingDates = [];
		this.monthlyBillingTotal = 0;
		serviceList.forEach((service) => {
			if (service.active) {
				if (service.billingFrequency?.toLowerCase() === "monthly") {
					this.monthlyBillingTotal += service.amount;
				}
				const billingDate = this.billingDates.find((i) => i.date === this.app.moment(service.nextBillingDate).format("l"));
				if (!billingDate) {
					this.billingDates.push({
						date: this.app.moment(service.nextBillingDate).format("l"),
						amount: service.amount,
					});
				} else {
					billingDate.amount += service.amount;
				}
			}
		});
		this.billingDates = Array.from(new Set(this.billingDates));
	}
}
